<template>
  <div>
    <b-row>
      <b-col sm="12" md="3">
        <Select2
          v-model="filters.headquarter"
          reduce
          label="Sede:"
          :options="headquartersSelectOptions"
          :loading="loadingHeadquartes"
        />
      </b-col>
      <b-col sm="12" md="3">
        <Select2
          v-model="filters.area"
          reduce
          label="Área"
          :options="areasOptions"
          :loading="loadingAreas"
          @input="filters.sub_area = null"
        />
      </b-col>
      <b-col sm="12" md="3">
        <Select2
          v-model="filters.sub_area"
          reduce
          label="Sub Área"
          :disabled="!filters.area"
          :options="subAreas"
        />
      </b-col>
      <b-col sm="12" md="3">
        <Select2
          label="Año"
          :options="years"
          appendToBody
          reduce
          v-model="filters.year"
        />
      </b-col>
      <b-col sm="12" md="3">
        <Select2
          label="Mes"
          appendToBody
          reduce
          :options="months"
          v-model="filters.month"
        />
      </b-col>
      <b-col sm="12" md="3">
        <Select2
          label="Quincena"
          appendToBody
          reduce
          :options="fortnights"
          v-model="filters.fortnight"
        />
      </b-col>
      <b-col sm="12" md="6">
        <Select2
          label="Tipos de Bonos"
          appendToBody
          reduce
          multiple
          :options="bondTypesOp"
          v-model="filters.bond_types"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-button
          size="sm"
          variant="dark"
          class="float-right mx-2"
          @click="$emit('clear')"
        >
          <i class="fas fa-ban mr-1" /> Limpiar
        </b-button>
        <b-button
          variant="primary"
          class="float-right"
          size="sm"
          @click="$emit('search')"
        >
          <i class="fas fa-search mr-1 "/> Filtrar
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { defineComponent, computed } from '@vue/composition-api'

// components
import { DatePicker, Select2 } from '@/components/general'

// hooks
import { useEmployeesOp, useBondType, useHeadquarter, useArea } from '@/hooks'

// constants
import { optionsStatus } from '@/constants'
import { dateLibs } from '@/utils'

export default defineComponent({
  name: 'FiltersBondControl',
  components: {
    Select2,
    DatePicker
  },
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  setup (props) {
    const years = dateLibs.createRangeYears()
    const months = dateLibs.getAllMonths()
    const fortnights = dateLibs.fortnightsDefault
    const { employeesOp } = useEmployeesOp()
    const { bondTypesOp } = useBondType()
    const { loadingHeadquartes, getHeadquatersActivated, headquartersSelectOptions } = useHeadquarter()
    getHeadquatersActivated()
    const { areasOptions, getAreasActive, loadingAreas, areas } = useArea()
    getAreasActive()

    const subAreas = computed(() => {
      const area = areas.value.find(area => Number(area.id) === Number(props.filters.area))
      if (area) {
        return area.subAreas.map(subArea => {
          return {
            value: subArea.id,
            text: subArea.name
          }
        })
      }
      return []
    })

    return {
      employeesOp,
      bondTypesOp,
      optionsStatus: [
        {
          text: 'TODOS',
          value: null
        },
        ...optionsStatus
      ],
      loadingHeadquartes,
      headquartersSelectOptions,
      loadingAreas,
      areasOptions,
      subAreas,
      years,
      months,
      fortnights
    }
  }
})
</script>
